/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Dropdown from "react-bootstrap/Dropdown";
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import objectPath from "object-path";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { clearAll } from "../../../../../redux/features/login/loginSlice";
import { removeAll } from "../../../../../redux/features/stakeholder/stakeholderSlice";
// Components
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { Button } from "@material-ui/core";
import { Urls } from "../../../../../app/utils/constants";
import { DropdownTopbarItemToggler } from "_metronic/_partials/dropdowns";
import "./userProfileDropDown.scss";

export function UserProfileDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const uiService = useHtmlClassService();
  const intl = useIntl();
  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const dispatch = useDispatch();
  const history = useHistory();
  const { person } = useSelector((state) => state.login);
  const { currentStakeholder } = useSelector((state) => state.stakeholder);

  const signOut = () => {
    dispatch(clearAll());
    dispatch(removeAll());
    // sessionStorage.removeItem("persist:root");
    // sessionStorage.removeItem("token");
    // sessionStorage.removeItem("asanLoginToken");
    // sessionStorage.removeItem("asanLoginIdToken");
    // localStorage.removeItem("currentStakeholder");
    // localStorage.removeItem("countries");
    // localStorage.removeItem("selectedVoen");
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = Urls.ASAN_Logout;
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const unlisten = history.listen(() => {
      setIsOpen(false);
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return (
    // <Dropdown isOpen={dropdownOpen} toggle={toggle}>
    //   <DropdownToggle caret style={{
    //     background: "transparent",
    //     height: 50,
    //     borderColor: "black",
    //     alignSelf: "center"
    //   }}>

    //     {`${currentStakeholder?.brandName
    //       ? currentStakeholder?.brandName
    //       : `${person?.name?.[0]}${person?.name.slice(1).toLowerCase()}`
    //       }`}

    //     {" | "}

    //     {currentStakeholder?.brandName?.[0]
    //       ? currentStakeholder?.brandName?.[0]
    //       : person?.name?.[0]}

    //   </DropdownToggle>
    //   <DropdownMenu right className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
    //     <DropdownItem text>
    //       <div >

    //         {layoutProps.light && (
    //           <>
    //             <div className="d-flex flex-column align-items-center p-5 rounded-top">
    //               <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h4 mb-2 text-center">
    //                 {currentStakeholder?.brandName}
    //               </div>
    //               <div className="label label-light-dark label-lg font-weight-bold label-inline">
    //                 ID : {currentStakeholder.uniqueId}
    //               </div>
    //             </div>
    //             <div className="separator separator-solid"></div>
    //           </>
    //         )}

    //         {!layoutProps.light && (
    //           <div
    //             className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
    //             style={{
    //               backgroundImage: `url(${toAbsoluteUrl(
    //                 "/media/misc/bg-1.jpg"
    //               )})`,
    //             }}
    //           >
    //             <div className="symbol bg-white-o-15 mr-3">
    //               <span className="symbol-label text-success font-weight-bold font-size-h4">
    //                 {person?.name}
    //               </span>
    //               {/* <img alt="Pic" className="hidden" src={user.pic} /> */}
    //             </div>
    //             <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
    //               {person?.surname}
    //             </div>
    //             <span className="label label-success label-lg font-weight-bold label-inline">
    //               3 messages
    //             </span>
    //           </div>
    //         )}
    //       </div>
    //     </DropdownItem>
    //     <DropdownItem>
    //       <div
    //         onClick={() => {
    //           if (currentStakeholder?.active) {
    //             history.push("/stakeholder/cabinet/profile-view");
    //           } else {
    //             history.push("/stakeholder/new/profile-view");
    //           }
    //         }}
    //       >
    //         <div>
    //           <div>
    //             <div className="font-weight-bold my_profile_title">
    //               {" "}
    //               <FormattedMessage id="my_profile" />{" "}
    //             </div>
    //             <div className="text-muted">
    //               <FormattedMessage id="my_profile_view" />
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //       {currentStakeholder?.status !== "IN PROGRESS" ? (

    //         <Button
    //           className="label label-light-primary label-inline font-weight-bold ml-5"
    //           onClick={() =>
    //             !currentStakeholder?.active
    //               ? history.push("/stakeholder/new/profile-view/edit")
    //               : history.push(
    //                 "/stakeholder/cabinet/profile-view/edit"
    //               )
    //           }
    //         >
    //           <FormattedMessage id="button.edit" />
    //         </Button>

    //       ) : null}
    //     </DropdownItem>

    //     <hr />

    //     {currentStakeholder?.active ? (

    //       <DropdownItem>
    //         <div className="d-flex justify-content-between">
    //           <div
    //             onClick={() => {
    //               if (currentStakeholder.classApp !== null) {
    //                 history.push(
    //                   "/stakeholder/cabinet/classification/view"
    //                 );
    //               } else {
    //                 history.push(
    //                   "/stakeholder/cabinet/classifications"
    //                 );
    //               }
    //             }}
    //           >
    //             <div className="font-weight-bold my_grade_application_title">
    //               <FormattedMessage id="key_classifications" />
    //             </div>
    //             <div className="text-muted">
    //               {currentStakeholder.classApp !== null ? (
    //                 <FormattedMessage id="key_my_view_classifications" />
    //               ) : (
    //                 <FormattedMessage id="key_creating_classifications" />
    //               )}
    //             </div>
    //           </div>

    //           {currentStakeholder.classApp?.status !== "new" &&
    //             currentStakeholder.classApp?.status !== "onprocess" ? (
    //             <div className="d-flex align-items-center">
    //               <Button
    //                 className="label label-light-primary label-inline font-weight-bold ml-5"
    //                 onClick={() =>
    //                   history.push(
    //                     "/stakeholder/cabinet/classifications"
    //                   )
    //                 }
    //               >
    //                 {currentStakeholder.classApp !== null ? (
    //                   <FormattedMessage id="button.edit" />
    //                 ) : (
    //                   <FormattedMessage id="menu.grade.application.create" />
    //                 )}
    //               </Button>
    //             </div>
    //           ) : null}
    //         </div>
    //       </DropdownItem>

    //     ) : null}

    //     {currentStakeholder.industrySubCategory !== null &&
    //       currentStakeholder.classApp?.status !== "rejected" ? (
    //       <DropdownItem>

    //         <div className="d-flex justify-content-between align-items-center my_grade_application">
    //           <div
    //             onClick={() =>
    //               history.push("/stakeholder/cabinet/grade-application")
    //             }
    //           >
    //             <div>
    //               <div>
    //                 <div className="font-weight-bold my_grade_application_title">
    //                   <FormattedMessage id="my_grade_applications" />
    //                 </div>
    //                 <div className="text-muted">
    //                   <FormattedMessage id="my_last_grade_application" />
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //           <Button
    //             className="label label-light-primary label-inline font-weight-bold ml-5"
    //             onClick={() =>
    //               history.push(
    //                 "/stakeholder/cabinet/grade-application/appeals"
    //               )
    //             }
    //           >
    //             <FormattedMessage id="menu.grade.application.apply" />
    //           </Button>
    //         </div>
    //       </DropdownItem>

    //     ) : null}

    //     <DropdownItem>
    //       <div
    //         className="navi-footer py-5"
    //         onClick={signOut}
    //       >
    //         <Link
    //           to="/logout"
    //           className="btn btn-light-danger font-weight-bold"
    //         >
    //           <FormattedMessage id="sign_out" />
    //         </Link>
    //       </div>
    //     </DropdownItem>
    //   </DropdownMenu>
    // </Dropdown>

    <Dropdown drop="down" alignRight show={isOpen} ref={dropdownRef}>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
        onClick={toggleDropdown}
      >
        <div
          className={
            "btn btn-ico btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto text-center navbar-login-cover"
          }
        >
          <span className=" font-weight-bold font-size-base d-none d-md-inline mr-1 navbar-login-cover-text">
            {/* <FormattedMessage id="hi" />,{" "} */}
            <span className="navbar-login-cover-top-text">
              {" "}
              {currentStakeholder?.name.replace(/OĞLU|QIZI/, "")}
            </span>{" "}
            <br />
            <span className="navbar-login-cover-bottom-text">
              {" "}
              {currentStakeholder?.industryCategory.name[intl.locale]}
            </span>
          </span>{" "}
          <span className="symbol symbol-35">
            <span className="symbol-label text-white font-size-h3 font-weight-bold bg-white-o-30 navbar-login-cover-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
              >
                <path
                  d="M10.2772 12.4897L14.9439 17.1564L19.6106 12.4897"
                  stroke="#F1EAFA"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <>
          {layoutProps.light && (
            <>
              <div className="d-flex flex-column align-items-center p-5 rounded-top">
                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h4 mb-2 text-center">
                  {currentStakeholder?.brandName}
                </div>
                <div className="label label-light-dark label-lg font-weight-bold label-inline">
                  ID : {currentStakeholder.uniqueId}
                </div>
              </div>
              <div className="separator separator-solid"></div>
            </>
          )}

          {!layoutProps.light && (
            <div
              className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
              style={{
                backgroundImage: `url(${toAbsoluteUrl(
                  "/media/misc/bg-1.jpg",
                )})`,
              }}
            >
              <div className="symbol bg-white-o-15 mr-3">
                <span className="symbol-label text-success font-weight-bold font-size-h4">
                  {person?.name}
                </span>
                {/* <img alt="Pic" className="hidden" src={user.pic} /> */}
              </div>
              <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
                {person?.surname}
              </div>
              <span className="label label-success label-lg font-weight-bold label-inline">
                3 messages
              </span>
            </div>
          )}
        </>

        <div className="navi navi-spacer-x-0 pt-1">
          <div className="navi-item px-8">
            <div className="navi-link d-flex justify-content-center align-items-center">
              <div className="navi-text" style={{ cursor: "pointer" }}>
                <div className="d-flex justify-content-between align-items-center my_profile">
                  <div
                    onClick={() => {
                      if (currentStakeholder?.active) {
                        history.push("/stakeholder/cabinet/profile-view");
                      } else {
                        history.push("/stakeholder/new/profile-view");
                      }
                    }}
                  >
                    <div>
                      <div>
                        <div className="font-weight-bold my_profile_title">
                          {" "}
                          <FormattedMessage id="my_profile" />{" "}
                        </div>
                        <div className="text-muted">
                          <FormattedMessage id="my_profile_view" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {currentStakeholder?.status !== "IN PROGRESS" ? (
                    <div>
                      <Button
                        className="label label-light-primary label-inline font-weight-bold ml-5"
                        onClick={() =>
                          !currentStakeholder?.active
                            ? history.push("/stakeholder/new/profile-view/edit")
                            : history.push(
                                "/stakeholder/cabinet/profile-view/edit",
                              )
                        }
                      >
                        <FormattedMessage id="button.edit" />
                      </Button>
                    </div>
                  ) : null}
                </div>
                {currentStakeholder?.active ? (
                  <>
                    <hr />
                    <div>
                      <div className="d-flex justify-content-between">
                        <div
                          onClick={() => {
                            if (currentStakeholder.classApp !== null) {
                              history.push(
                                "/stakeholder/cabinet/classification/view",
                              );
                            } else {
                              history.push(
                                "/stakeholder/cabinet/classifications",
                              );
                            }
                          }}
                        >
                          <div className="font-weight-bold my_grade_application_title">
                            <FormattedMessage id="key_classifications" />
                          </div>
                          <div className="text-muted">
                            {currentStakeholder.classApp !== null ? (
                              <FormattedMessage id="key_my_view_classifications" />
                            ) : (
                              <FormattedMessage id="key_creating_classifications" />
                            )}
                          </div>
                        </div>

                        {currentStakeholder.classApp?.status !== "new" &&
                        currentStakeholder.classApp?.status !== "onprocess" ? (
                          <div className="d-flex align-items-center">
                            <Button
                              className="label label-light-primary label-inline font-weight-bold ml-5"
                              onClick={() =>
                                history.push(
                                  "/stakeholder/cabinet/classifications",
                                )
                              }
                            >
                              {currentStakeholder.classApp !== null ? (
                                <FormattedMessage id="button.edit" />
                              ) : (
                                <FormattedMessage id="menu.grade.application.create" />
                              )}
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : null}
                <hr />

                {currentStakeholder.industrySubCategory !== null &&
                currentStakeholder.classApp?.status !== "rejected" ? (
                  <div className="d-flex justify-content-between align-items-center my_grade_application">
                    <div
                      onClick={() =>
                        history.push("/stakeholder/cabinet/grade-application")
                      }
                    >
                      <div>
                        <div>
                          <div className="font-weight-bold my_grade_application_title">
                            <FormattedMessage id="my_grade_applications" />
                          </div>
                          <div className="text-muted">
                            <FormattedMessage id="my_last_grade_application" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <Button
                      className="label label-light-primary label-inline font-weight-bold ml-5"
                      onClick={() =>
                        history.push(
                          "/stakeholder/cabinet/grade-application/appeals",
                        )
                      }
                    >
                      <FormattedMessage id="menu.grade.application.apply" />
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <div className="navi-separator mt-3"></div>

          <div
            className="navi-footer px-8 py-5 justify-content-end"
            onClick={signOut}
          >
            <Link to="/logout" className="btn text-white font-weight-bold">
              <FormattedMessage id="sign_out" />
            </Link>
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
